import './lib/fetch-base-url'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './index.css'

// Iframe theme handshake — same protocol seed portals use. Nursery hosts
// this portal in an iframe and drives its theme via Settings → "App
// appearance". Apply ?_dark on boot (before React mounts, to avoid the
// initial light flash), then listen for set-dark-mode at runtime. Both
// light and dark CSS vars already live in index.css; toggling the `dark`
// class on <html> switches between them.
if (new URLSearchParams(location.search).has('_dark')) {
  document.documentElement.classList.add('dark')
}
window.addEventListener('message', (e) => {
  if (e.data?.type === 'set-dark-mode') {
    document.documentElement.classList.toggle('dark', !!e.data.dark)
  }
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)
